import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import './style.scss';

const CustomSelect = ({  selected="", children, chevronSize = 14, selectStyles={} }) => {
    const [showSelect, setShowSelect] = useState(false);
  
    const handleShowClick = e => {
      setShowSelect(!showSelect);
    };

  return (
    <div className="custom-select" onClick={e => handleShowClick(e)} style={selectStyles}>
        <div className="custom-select__selected">
          <span>{selected}</span>
          <FaChevronDown size={chevronSize} />
        </div>
        {showSelect && (
          <ul className="custom-select__list">
            { children }
          </ul>
        )}
      </div>
  )
}

export default CustomSelect
